module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit(_vm.item)
      }
    }
  }, [_c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.name)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_name"
    }
  }, [_vm._v("Imię")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.name),
      expression: "item.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_name"
    },
    domProps: {
      "value": (_vm.item.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.name) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_name_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.surname)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_surname"
    }
  }, [_vm._v("Nazwisko")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.surname),
      expression: "item.surname"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "_surname"
    },
    domProps: {
      "value": (_vm.item.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.surname) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_surname_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.surname))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.email)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_email"
    }
  }, [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.email),
      expression: "item.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "_email"
    },
    domProps: {
      "value": (_vm.item.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors && _vm.errors.email) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_email_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.email))]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: {
      'form-group': true, 'has-error': (_vm.errors && _vm.errors.roles)
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "_roles"
    }
  }, [_vm._v("Role")]), _vm._v(" "), _c('div', {
    staticClass: "select__container form-group"
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "multiple": "",
      "options": _vm.userRoles,
      "id": "_roles"
    },
    model: {
      value: (_vm.item.roles),
      callback: function($$v) {
        _vm.$set(_vm.item, "roles", $$v)
      },
      expression: "item.roles"
    }
  })], 1), _vm._v(" "), (_vm.errors && _vm.errors.roles) ? _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "_roles_helpBlock"
    }
  }, [_vm._v(_vm._s(_vm.errors.roles))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'UserList'
      }
    }
  }, [_c('span', [_vm._v("Powrót")]), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1), _vm._v(" "), _c('my-button', {
    attrs: {
      "text": "Zapisz",
      "icon": "tick",
      "type": "submit"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-547ba214","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Form.vue
// module id = 818
// module chunks = 0